/**
 * Routes that own their own IN-PLACE dead-session recovery (a sign-in modal
 * surfaced on top of the current page — see helpers/auth.helpers.ts for
 * /incentive, and AdminLayoutComponent's chromeless `<app-header
 * [loginOnly]="true">` for /admin) and must NEVER be hard-reloaded or
 * navigated away from by auth.interceptor.ts's handleSessionExpired().
 *
 * Extracted to a pure function (rather than left as an inline array literal
 * in the interceptor) specifically so this branch — which decides whether a
 * dead session silently destroys whatever page/form the user was on — is
 * unit-testable without exercising the rest of the interceptor's
 * HttpClient/Router-dependent machinery. See auth.interceptor.ts's
 * handleSessionExpired doc comment for the full incident history (2026-07-17
 * KY /incentive hard-reload; extended to /admin 2026-07-20 for PR-C's
 * heartbeat, which would otherwise have every admin-route 401 win a race
 * against this exact check and navigate the admin user to /locations before
 * the in-place recovery modal could ever show).
 */
export function isInPlaceSessionRecoveryPath(path: string): boolean {
  return path.startsWith('/incentive') || path.startsWith('/admin');
}
